import React from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface SearchSectionProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const SearchSection = ({ searchTerm, setSearchTerm }: SearchSectionProps) => {
  return (
    <div>
      <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-end mb-10">
        <div className="md:col-span-7">
          <span className="ed-eyebrow">Signalements récents</span>
          <h2 className="ed-heading text-3xl md:text-5xl mt-5">
            Le pouls <span className="accent">de votre commune</span>
          </h2>
          <p className="ed-subtle text-base md:text-lg mt-4 max-w-xl">
            Découvrez et soutenez les derniers signalements. Ensemble, nous faisons la différence.
          </p>
        </div>
        <div className="md:col-span-5">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-[var(--ed-navy-500)] h-4 w-4" />
            <Input
              type="text"
              placeholder="Rechercher un signalement..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-11 h-12 bg-white border border-[var(--ed-rule-strong)] rounded-none font-body focus-visible:ring-0 focus-visible:border-[var(--ed-navy-800)]"
            />
          </div>
        </div>
      </div>
      <div className="ed-rule" />
    </div>
  );
};

export default SearchSection;
